<mat-tab-group style="width:100%;" [selectedIndex]="selectedItemIndex" (selectedIndexChange)="indexChanged($event)">
    <mat-tab *ngFor="let item of items">
      <ng-template mat-tab-label>
        <div class="small-tab-label" (click)="selectItem(item)">
            <fa-icon class="left-icon-item-tab" [icon]="item.mapping.icon"></fa-icon>
            <fa-icon class="left-icon-item-tab" [icon]="item.typeIcon"></fa-icon>
            <span>{{ item?.item?.title }}</span>
            <fa-icon class="right-icon-item-tab" [ngClass]="itemIconClass(item)" [icon]="['fas', 'circle']"></fa-icon>
            <button class="right-icon-item-tab" mat-icon-button style="width:16px;height:30px;" (click)="closeItem($event,item)"><fa-icon [icon]="['fas', 'times']" size="lg"></fa-icon></button>
        </div>
      </ng-template>
    </mat-tab>
</mat-tab-group>    
